import React from "react";
import { useAdminOperationLogList } from "../../../../hooks/admin/admin_operation_log/useAdminOperationLogList";
import { getLabelFromOperationTarget } from "../../../../../domain/admin_operation_log/OperationTarget";
import { getLabelFromOperationType } from "../../../../../domain/admin_operation_log/OperationType";
import { Paths } from "../../../../../Paths";

export const AdminOperationLogTableBody = React.memo(function AdminOperationLogTableBody() {
    const adminOperationLogList = useAdminOperationLogList();

    return (
        <tbody>
            {adminOperationLogList.map((adminOperationLog, index) => (
                <tr key={`${index}${adminOperationLog.userId.value}${adminOperationLog.operationTime.format()}`}>
                    <td className={"number"}>{(index + 1)}</td>
                    <td className={"operation_user"}>
                        <a
                            href={`${Paths.admin}${Paths.user}${Paths.edit}/${adminOperationLog.userId.value}`}
                            target="blank"
                        >
                            操作ユーザー詳細
                        </a>
                    </td>
                    <td>{getLabelFromOperationTarget(adminOperationLog.operationTarget)}</td>
                    <td>{getLabelFromOperationType(adminOperationLog.operationType)}</td>
                    <td className={"operation_content"}>{adminOperationLog.operationContentBefore.value}</td>
                    <td className={"operation_content"}>{adminOperationLog.operationContentAfter.value}</td>
                    <td>{adminOperationLog.operationTime.format()}</td>
                </tr>
            ))}
        </tbody>
    );
});
